import { render, staticRenderFns } from "./TaskValue.vue?vue&type=template&id=4c09ce61&scoped=true"
import script from "./TaskValue.vue?vue&type=script&lang=js"
export * from "./TaskValue.vue?vue&type=script&lang=js"
import style0 from "./TaskValue.vue?vue&type=style&index=0&id=4c09ce61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09ce61",
  null
  
)

export default component.exports